// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  loading: false,
  // API_URL: 'http://192.168.15.22:3003',
  // API_URL: 'http://18.231.183.68:3003',
  // API_URL: 'https://api.mobisaude.com:3003',
  // API_URL: "http://192.168.15.26",
  // API_URL: "http://192.168.15.6",
  // API_URL: "http://192.168.0.18",
  // API_URL: "http://192.168.15.2",
  // API_URL: "http://192.168.42.208",

  // API_URL: "http://192.168.0.101",
  // API_URL: "http://52.90.75.235", // HMLG
  // API_URL: "http://192.168.15.26",
  // API_URL: "http://192.168.15.20",
  API_URL: "https://apihmlg.youdoctor.com.br", // HMLG V2
  // API_URL: "https://apihmlg.youdoctor.com.br",

  toggleMenu: false,
  pageTitle: "Seja Bem-Vindo!"
};
